/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

document.addEventListener("DOMContentLoaded", function() {
    const zoomContainers = document.querySelectorAll('.zoom-container-hover');
    zoomContainers.forEach(container => {
        const img = container.querySelector('img');

        // The page shows the detail size; the zoom size (data-zoom-src) is only fetched when
        // someone actually zooms. Swapped once it is loaded, so the picture never goes blank.
        function loadZoomSource() {
            const zoomSrc = img.dataset.zoomSrc;
            if (!zoomSrc) {
                return;
            }
            img.removeAttribute('data-zoom-src');
            const big = new Image();
            big.onload = () => { img.src = zoomSrc; };
            big.src = zoomSrc;
        }
        img.addEventListener('mouseover', loadZoomSource, { once: true });
        img.addEventListener('touchstart', loadZoomSource, { once: true, passive: true });

        function setOrigin(clientX, clientY) {
            const rect = img.getBoundingClientRect();
            const xPercent = ((clientX - rect.left) / rect.width) * 100;
            const yPercent = ((clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        }

        // --- Mouse: hover to zoom, move to pan ---
        img.addEventListener('mouseover', function() {
            img.classList.add('zoom');
        });

        container.addEventListener('mouseout', function() {
            img.classList.remove('zoom');
        });

        img.addEventListener('mousemove', function(e) {
            if (img.classList.contains('zoom')) {
                setOrigin(e.clientX, e.clientY);
            }
        });

        // --- Touch: tap to toggle zoom, drag to pan ---
        let touchStartX = 0;
        let touchStartY = 0;
        let isDragging = false;

        img.addEventListener('touchstart', function(e) {
            if (e.touches.length > 1) {
                return;
            }
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            isDragging = false;
        }, { passive: true });

        img.addEventListener('touchmove', function(e) {
            if (e.touches.length > 1) {
                return;
            }

            const dx = Math.abs(e.touches[0].clientX - touchStartX);
            const dy = Math.abs(e.touches[0].clientY - touchStartY);

            if (dx > 5 || dy > 5) {
                isDragging = true;
            }

            if (img.classList.contains('zoom') && isDragging) {
                e.preventDefault();
                setOrigin(e.touches[0].clientX, e.touches[0].clientY);
            }
        }, { passive: false });

        img.addEventListener('touchend', function(e) {
            if (isDragging) {
                return;
            }
            // Tap: toggle zoom
            img.classList.toggle('zoom');
        });

        // Prevent click from double-toggling on touch devices
        img.addEventListener('click', function(e) {
            if ('ontouchstart' in window) {
                e.preventDefault();
            }
        });
    });
});
